import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class LCDGraphWidgetNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LCD Line Graph Add Point';
        this.id = 'node_lcd_graph_widget';
        this.linkedFeature = 'lcd';
        this.icon = 'CgScreen';

        this.inputs = [
            {
                name: 'Draw Line',
                portId: 'lcd_print_line',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'WIDGET',
                name: 'Widget',
                settingType: SettingType.OPTION,
                refId: 'lcd_graph_widget',
                required: true,
                default: '',
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRINGVARIABLE,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            }
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const widget = project.getFeature(this.getSettingValue('WIDGET'));

        if (!widget) {
            return blocks;
        }

        const SCREEN = project.getParent(widget);
        const displayFeature = project.getParent(SCREEN);
        const screens = displayFeature.getSettingValue('SCREENS');
        let widgetIndex = 0;
        let tmpWidgetIndex = 0;
        let screenIndex = 0;

        for (let j = 0; j < screens.length; j++) {
            const screen = screens[j];
            const widgets = screen.getSettingValue('WIDGETS');
            for (let i = 0; i < widgets.length; i++) {
                const currentWidget = widgets[i];
                const type = currentWidget.id;
                switch (type) {
                    case 'lcd_graph_widget':
                        if (currentWidget.getID() === widget.getID()) {
                            widgetIndex = tmpWidgetIndex;
                            break;
                        }
                        tmpWidgetIndex++;
                        break;
                }
            }
            if (screen.getID() === SCREEN.getID()) {
                screenIndex = j;
                break;
            }
        }

        const VALUE = project.parseCodeExpression(this.getSettingValue('VALUE'), [], TibboDataType.FLOAT);

        const links = project.getNodeLinks(this, 'lcd_print_line');
        const doneLinks = project.getNodeLinks(this, 'done');

        const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    if true then
        dim i as byte
        if lcd_graph_widgets(${widgetIndex}).current_index <= lcd_graph_widgets(${widgetIndex}).max_points then
            lcd_graph_widgets(${widgetIndex}).current_index = lcd_graph_widgets(${widgetIndex}).current_index + 1
        else
            for i=1 to lcd_graph_widgets(${widgetIndex}).max_points + 1
                lcd_graph_widgets(${widgetIndex}).points(i-1) = lcd_graph_widgets(${widgetIndex}).points(i)
            next i
        end if
        lcd_graph_widgets(${widgetIndex}).points(lcd_graph_widgets(${widgetIndex}).current_index) = ${VALUE}
        lcd_graph_widgets(${widgetIndex}).points(lcd_graph_widgets(${widgetIndex}).current_index) = ${VALUE}
    end if

    if display_current_screen = ${screenIndex} then
		lcd_draw_graph(lcd_graph_widgets(${widgetIndex}))
    end if
    ${doneBlock}`,
            });
        }


        return blocks;
    }

    getDetails(): string {
        return 'Adds a datapoint to the LCD screen chart of the selected widget. The datapoint is the current value of the widget\'s variable.';
    }
}
